import { cn } from "@/lib/utils";

/**
 * Skeleton with an animated shimmer gradient. Respects
 * `prefers-reduced-motion` (falls back to a static muted block).
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("skeleton-shimmer rounded-md", className)}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Skeleton };
